import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const DISMISS_KEY = 'hilanta_promo_banner_dismissed';

export default function PromoBanner() {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/promo-codes/public-banner`)
      .then((res) => {
        if (!mounted) return;
        if (res.data && res.data.code) {
          // Reset dismiss state when the code changes
          const previousCode = sessionStorage.getItem(DISMISS_KEY);
          if (previousCode === res.data.code) {
            setDismissed(true);
          }
          setPromo(res.data);
        }
      })
      .catch(() => {
        /* silent — no banner */
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!promo || dismissed) return null;

  const discountLabel =
    promo.discount_type === 'percentage'
      ? `-${promo.discount_value}%`
      : `-${promo.discount_value} €`;

  const handleClick = () => {
    // Pre-fill the code via querystring and route to the gift card page
    navigate(`/carte-cadeau?promo=${encodeURIComponent(promo.code)}`);
  };

  const handleDismiss = (e) => {
    e.stopPropagation();
    sessionStorage.setItem(DISMISS_KEY, promo.code);
    setDismissed(true);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleClick()}
      data-testid="public-promo-banner"
      className="cursor-pointer bg-gradient-to-r from-rose-700 via-rose-600 to-amber-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm sm:text-base font-medium tracking-wide shadow-sm hover:brightness-110 transition-all"
    >
      <span className="text-center">
        <span className="hidden sm:inline">Offre spéciale : </span>
        Code{' '}
        <strong className="font-bold tracking-wider bg-white/15 px-2 py-0.5 rounded">
          {promo.code}
        </strong>{' '}
        = <strong>{discountLabel}</strong>
        {promo.description && (
          <span className="opacity-90"> — {promo.description}</span>
        )}
      </span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Fermer le bandeau"
        className="ml-2 p-1 rounded-full hover:bg-white/15 transition-colors flex-shrink-0"
        data-testid="public-promo-banner-dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
}
